export default function DownloadSvg() {
  return <svg  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 14H15" stroke="black" strokeWidth='1.45px'/>
    <path d="M3 7L8 12L13 7" stroke="black" strokeWidth='1.45px'/>
    <line x1="8" y1="12" x2="8" y2="1" stroke="black" strokeWidth='1.45px'/>
  </svg>
}